/**
 * PyDialog brand mark — a self-contained SVG (no external assets).
 *
 * An ink tile carrying a speech bubble, with the three dots set as a marker's
 * tick sequence in ochre. Solid ink rather than a gradient: the mark should
 * read as something printed on a paper, not as a SaaS logo.
 */
type LogoProps = {
  size?: number;
  className?: string;
};

const INK = "#16202e";
const SEAL = "#c8912f";

export function Logo({ size = 28, className }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="PyDialog logo"
    >
      <rect width="32" height="32" rx="8" fill={INK} />
      {/* speech bubble */}
      <path
        d="M8 12.5A3.5 3.5 0 0 1 11.5 9h9A3.5 3.5 0 0 1 24 12.5v4A3.5 3.5 0 0 1 20.5 20H15l-4.2 3.1a.6.6 0 0 1-.96-.48V20h.16A3.5 3.5 0 0 1 8 16.5z"
        fill="#ffffff"
      />
      {/* dialog dots, weighted like a marker working left to right */}
      <circle cx="12.5" cy="14.5" r="1.4" fill={SEAL} />
      <circle cx="16" cy="14.5" r="1.4" fill={SEAL} opacity="0.72" />
      <circle cx="19.5" cy="14.5" r="1.4" fill={SEAL} opacity="0.44" />
    </svg>
  );
}
